module.exports = __webpack_public_path__ + "assets/img/ko-014dfdee.png";